import TeachersRoutes from './teacher'

const TeacherRoutes = [
  ...TeachersRoutes
]

export default TeacherRoutes
